import { Mail, QrCode, ScanQrCode, Search } from 'lucide-react'
import { useState } from 'react'
import type { Action } from '@/components/ActionMenu'
import { useMe } from '@/lib/useMe'
import { EmailDialog } from './Connect'
import { FindPeople } from './FindPeople'
import { MyLink } from './MyLink'
import { Scan } from './Scan'

type Adding = 'scan' | 'qr' | 'email' | 'search' | null

// The ways to connect with someone new, for People's "+": scanning their QR code, showing yours (or your link), their
// email address, or Search.
// `dialogs` goes on the page once.
export function useAddConnection() {
  const [adding, setAdding] = useState<Adding>(null)
  const name = useMe().data?.name ?? ''
  const close = () => setAdding(null)
  const actions: Action[] = [
    { label: 'Scan a QR code', icon: ScanQrCode, onSelect: () => setAdding('scan') },
    { label: 'My QR code', icon: QrCode, onSelect: () => setAdding('qr') },
    { label: 'Connect by email', icon: Mail, onSelect: () => setAdding('email') },
    { label: 'Search people', icon: Search, onSelect: () => setAdding('search') },
  ]
  const dialogs = (
    <>
      <Scan open={adding === 'scan'} onClose={close} />
      <MyLink open={adding === 'qr'} onClose={close} name={name} />
      <EmailDialog open={adding === 'email'} onClose={close} />
      <FindPeople open={adding === 'search'} onClose={close} />
    </>
  )
  return { actions, dialogs }
}
